import qs from "qs";
import { API } from "../../../utils";

export const getFullTaxInvoicesApi = async (params) => {
  const response = await API.get("ftis", {
    params,
    paramsSerializer: (params) => qs.stringify(params),
  });
  return response.data;
};

export const createFtiApi = async (orderId, payload) => {
  const response = await API.post(`ftis/${orderId}`, payload);
  return response.data;
};

export const exportFtiPdfApi = async (id) => {
  const response = await API.get(`ftis/${id}/export`, {
    responseType: "blob",
  });
  return response;
};

// Cancels the FTI and issues a new one with the given business details
export const cancelAndReissueFtiApi = async (id, payload) => {
  const response = await API.post(`ftis/${id}/cancel-reissue`, payload);
  return response.data;
};

export const getFtiDetailsApi = async (id) => {
  const response = await API.get(`ftis/${id}`);
  return response.data;
};

export const getFtiDaysSettingApi = async () => {
  const response = await API.get("settings/fti");
  return response.data;
};

export const updateFtiDaysSettingApi = async (payload) => {
  const response = await API.put("settings/fti", payload);
  return response.data;
};
